/**
 * Custom jQuery plugin to toggle display of search modalt
 *
 * @since		09/21/2020
 * @author		<john@chatmandesign.com>
 * @link		http://chatmandesign.com
 */
jQuery.fn.cdSearchModal = function() {
	let $s = this;
	let $button = $s.find('.search-submit');
	let $overlay = $('.search-modal__overlay').first();
	var $field = $('.search-modal__overlay').find('.search-field');
	let $overlayButton = $('.search-modal__overlay').find('.search-submit');

	function cdOpenSearchModal() {
		$overlay.css('display', 'block');
		setTimeout(() => {
			$overlay.addClass('transition');
			$field.focus();
		}, 100); // slight delay to make sure transition is smooth
	}

	function cdCloseSearchModal() {
		$overlay.removeClass('transition');
		setTimeout(() => {
			$overlay.css('display', 'none');
		}, 1000); // 1s for fade-out and circle scale
	}

	if( $overlay.length ) {
		$overlay.appendTo('body');
	}

	$button.on('click', function(e){
		e.preventDefault();
		cdOpenSearchModal();
	});

	$button.on('keydown', function(e){
		let keyCode = (e.keyCode ? e.keyCode : e.which);   
		if (keyCode == 13) {
			cdOpenSearchModal();
		}
	});

	$field.on('blur', function(e){
		if(e.relatedTarget != null && e.relatedTarget.nodeName == 'INPUT') {
			$overlayButton.on('blur', function() {
				cdCloseSearchModal();
			})
		} else {
			cdCloseSearchModal();
		}
	});
}
jQuery('.search-modal').cdSearchModal();
